module.exports = __webpack_public_path__ + "static/media/tag_animation.c4a7d42c.svg";